import { render, staticRenderFns } from "./InviteHeader.vue?vue&type=template&id=12aa5cb3&"
import script from "./InviteHeader.vue?vue&type=script&lang=js&"
export * from "./InviteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports